<template>
  <nav>
    <v-row
      class="fill-height"
      align="center"
    >
      <v-col
        cols="12"
        sm="4"
        offset-sm="4"
      >
        <AlertMessages
          v-if="alertValue"
          :alert-type="alertType" 
          :alert-msg="alertMsg"
          @reset="alertValue = false"
        />
        <v-card
          v-if="checkingCompleted"
          elevation="0"
          rounded="xxl"
          color="background"
        > 
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t('shareActivityTitleCSVCompleted') }}
          </v-card-title>
          <v-card-subtitle
            v-if="validEmails.length == 0"
            class="text-body-1 error--text no-break pb-0 text-center"
          >
            {{ $t('shareActivityDescriptionCSVCompletedNoFileInfo') }}
          </v-card-subtitle>
          <v-card-subtitle
            v-else
            class="text-body-1 darktext--text no-break pb-0 text-center"
          >
            <!-- eslint-disable vue/no-v-html -->
            <span
              v-if="memberEmails.length > 0"
              v-html="$t('shareActivityDescriptionCSVCompletedAlreadyMembers')"
            />&nbsp;
            <span
              v-if="notValidEmails.length > 0"
              v-html="$t('shareActivityDescriptionCSVCompletedNotValidEmails')"
            />
          </v-card-subtitle>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent
          >
            <v-btn
              data-testid="upload-button-center"
              :disabled="loadingCSV"
              color="greytext"
              class="no-hover text-body-1 white--text text-none rounded-xxl px-4 mx-auto d-block my-10"
              :ripple="false"
              elevation="0"
              @click="showUploadCSVFile()"
            >
              {{ $t('changeCSV') }}
            </v-btn>
            <span class="text-body-1">{{ $t('mail') }}</span><span class="float-right text-body-1">{{ $t('total') }}: {{ externalEmails.length + notMemberEmails.length }}</span>
            <v-divider />
            <div
              v-if="validEmails.length>0"
              style="max-height: 300px;"
              class="overflow-y-auto"
            >
              <v-list class="pa-0 background">
                <v-list-item
                  v-for="(email, index) in memberEmails"
                  :key="index"
                  dense
                >
                  <span class="warning--text">{{ email }}</span>
                </v-list-item>
              </v-list>
              <v-list class="pa-0 background">
                <v-list-item
                  v-for="(email, index) in notValidEmails"
                  :key="index"
                  dense
                >
                  <span class="error--text">{{ email }}</span>
                </v-list-item>
              </v-list>
              <v-list class="pa-0 background">
                <v-list-item
                  v-for="(email, index) in notMemberEmails"
                  :key="index"
                  dense
                >
                  <span class="greytext--text">{{ email }}</span>
                </v-list-item>
              </v-list>
              <v-list class="pa-0 background">
                <v-list-item
                  v-for="(email, index) in externalEmails"
                  :key="index"
                  dense
                >
                  <span class="greytext--text">{{ email }}</span>
                </v-list-item>
              </v-list>
            </div>
            <div
              v-else
              style="height: 300px;"
              class="overflow-y-auto d-flex align-center justify-center"
              data-testid="no-file-info-message"
            >
              <span class="greytextlight--text text-h6 text-md-h5 font-weight-bold">{{ $t('noFileInfo') }}</span>
            </div>
            <v-file-input 
              ref="file_input"
              v-model="CSVData"
              accept=".csv"
              data-testid="file-input"
              class="d-none"
              @change="uploadCSV"
            />
            <v-divider class="mb-15" />
            <v-textarea
              v-if="checkingCompleted"
              v-model="message"
              data-testid="message-textarea"
              rounded
              auto-grow
              solo
              name="textarea"
              :placeholder="$t('shareActivityMessageField')"
            />                   
          </v-form>
        </v-card>

        <v-card
          v-else
          elevation="0"
          rounded="xxl"
          color="background"
        > 
          <v-card-title class="text-h5 font-weight-bold text-center justify-center mb-4 no-break">
            {{ $t('shareActivityTitleCSV') }}
          </v-card-title>
          <v-card-subtitle class="text-body-1 darktext--text no-break pb-0 text-center">
            {{ $t('shareActivityDescriptionCSV') }}
          </v-card-subtitle>
          <v-form
            ref="form"
            v-model="valid"
            @submit.prevent
          >
            <v-divider class="my-15" />
            <v-row
              class="custom-border"
              style="height: 200px;"
              align="center"
              @click="showUploadCSVFile()"
            >
              <v-col
                cols="4"
                offset="4"
                align-self="center"
                align="center"
              >
                <v-btn
                  data-testid="upload-button-center"
                  :disabled="loadingCSV"
                  color="greytext"
                  class="no-hover text-body-1 white--text text-none rounded-xxl px-4 mx-auto d-block mb-2"
                  :ripple="false"
                  block
                  elevation="0"
                >
                  {{ $t('chooseCSV') }}
                </v-btn>
                <span class="grey--text text-body-2 align-center">{{ $t('shareActivityDescriptionCSVUpload') }}</span>
              </v-col>
            </v-row>


            <v-file-input 
              ref="file_input"
              v-model="CSVData"
              accept=".csv"
              data-testid="file-input"
              class="d-none"
              @change="uploadCSV"
            />
            <v-divider class="mt-15" />                 
          </v-form>
        </v-card>
         
        <v-row>
          <v-col align="center">
            <FormFooter
              next-button-text="share"
              :loading="loading"
              :cancel-button-link="cancelLink"
              :hide-submit="!checkingCompleted || validEmails.length == 0"
              @proceedSubmit="shareActivity"
            />
          </v-col>
        </v-row>
      </v-col>
    </v-row>             
  </nav>
</template>
<script>
import i18n from '../../plugins/i18n'
import { checkUserBatch, shareActivity } from '../../api/activityApi'
import FormFooter  from '../../components/FormFooter'
import AlertMessages  from '../../components/AlertMessages'

export default {
    components: {
        FormFooter,
        AlertMessages
    },
    data () {
        return {
            spaceId: window.$cookies.get('space_id'),
            alertMsg:'',
            alertValue:false,
            loading: false,
            valid: true,
            message: '',
            cancelLink:'/activity/'+this.$route.params.id,
            previousRoute: null,
            loadingCSV: false,
            CSVData: null,
            validEmails: [],
            notValidEmails: [],
            checkingCompleted: false,
            memberEmails: [],
            notMemberEmails: [],
            externalEmails: [],
        }
    },
    beforeRouteEnter(to, from, next) {
        if(from.path != null && from.path != '/redirect' && from.path != '/'){
            next(vm => {
                vm.cancelLink = from.path,
                vm.previousRoute = from
            });
        }else { 
            next();
        }
        
    },
    methods: {
        showUploadCSVFile(){
            this.$refs.file_input.$refs.input.click()
        },
        async uploadCSV(){
            this.loadingCSV = true
            await this.parseFile()
            this.$refs.file_input.$refs.input.value = ''
        },
        async parseFile(){
            if(this.$papa){
                await this.$papa.parse(this.CSVData, {
                    header: false,
                    skipEmptyLines: true,
                    delimitersToGuess: [
                    ",",
                    "\t",
                    "|",
                    ";",
                    ],
                    complete: this.onComplete
                });
            }
        },
        async onComplete(results) {
            this.validEmails= []
            this.notValidEmails= []
            this.memberEmails= []
            this.notMemberEmails= []
            this.externalEmails= []

            if(results.data.length > 0){
                results.data.forEach((value) => {
                    if(this.validateEmail(value[0])){
                        this.validEmails.push(value[0])

                    }else{
                        this.notValidEmails.push(value[0])

                    }               
                })
            }

            if(this.validEmails.length > 0){
                try {
                    let data = {
                        data: {
                            type: "activity-users",
                            attributes: {
                                user_email: this.validEmails
                            }
                        }
                    };
                    const response = await checkUserBatch(this.$route.params.id, data)
                    if(response.status == 200){
                        this.checkingCompleted = true
                        
                        for (const [key, value] of Object.entries(response.data.meta.users)) {
                            if(value == 'memberAlready'){
                                this.memberEmails.push(key)
                            }else if(value == 'notMember'){
                                this.notMemberEmails.push(key)
                            }else if(value == 'soft_deleted'){
                                this.memberEmails.push(key)
                            }else {
                                //value == 'external'
                                this.externalEmails.push(key)
                            }
                        }
                    }
                }catch (e) {
                    if(e.response){
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    } 
                }
            }else{
                this.checkingCompleted = true
            }

            this.loadingCSV = false
        },

        validateEmail(elementValue){
            /*
            //Regex value to validate email
            //var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            var emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/

          // Return true if the value is valid and false if not valid
            return emailPattern.test(elementValue);
            //var filter = /^\s*[\w\-\+_]+(\.[\w\-\+_]+)*\@[\w\-\+_]+\.[\w\-\+_]+(\.[\w\-\+_]+)*\s*$/;
            //return String(e).search (filter) != -1;
            */
          //Regex value to validate email
            var emailPattern = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/
          // Return true if the value is valid and false if not valid
            return emailPattern.test(elementValue);
        
        },

        async shareActivity(){
            this.$refs.form.validate()
            if(this.valid){
                this.loading = true
                try {
                    let data = {
                        data: {
                            type: "activity-users", 
                            attributes: {
                                user_email: this.memberEmails.concat(this.notMemberEmails).filter(n => n),
                                external_emails: this.externalEmails.filter(n => n),
                                message: this.message
                            }
                        }
                    };
                    const response = await shareActivity(this.$route.params.id, data)
                    if(response.status == 200) {
                        if(this.previousRoute){
                            if(this.previousRoute.name !== null){
                                var params = this.previousRoute.params
                                params.successfullySharedActivity = true
                                this.$router.push({name: this.previousRoute.name, params: params})
                            }else {
                                this.$router.push({name: 'ViewActivityPage', params: {id: this.$route.params.id, successfullySharedActivity: true}})
                            }
                        }else{
                            this.$router.push({name: 'ViewActivityPage', params: {id: this.$route.params.id, successfullySharedActivity: true}})
                        }
                    }            
                } catch (e) {
                    if(e.response){
                        this.alertValue = true
                        if (e.response.status == 403){
                            this.$router.push({name: 'PageAccessDenied'})
                        } else if(e.response.status == 404) {
                            this.$router.push({name: 'PageNotFound'})
                        } else {
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError')
                        }
                    }            
                }
                this.loading =false
            }
            
        }    
    }
}

</script>